import { type ReactNode } from 'react';
import { Avatar } from '@/components/ui/avatar';
import type { Creator } from '@/types';
import { formatFollowers, formatDate } from '@/utils/formatters';
import { creatorPhotoUrl } from '@/utils/creator-helpers';

const TD = 'px-md py-sm';
const TR =
  'cursor-pointer border-b border-white/[0.03] transition-colors hover:bg-white/[0.05]';

function UserCell({ creator }: { creator: Creator }): ReactNode {
  return (
    <td className={TD}>
      <div className="flex items-center gap-sm">
        <Avatar
          src={creatorPhotoUrl(creator)}
          name={creator.ig_username}
          size="sm"
        />
        <div className="min-w-0">
          <p className="truncate text-[13px] text-text-primary">
            @{creator.ig_username}
          </p>
          <p className="truncate text-[11px] text-text-tertiary">
            {creator.display_name}
          </p>
        </div>
      </div>
    </td>
  );
}

function Row({
  creator,
  onClick,
}: {
  creator: Creator;
  onClick: () => void;
}): ReactNode {
  return (
    <tr className={TR} onClick={onClick}>
      <UserCell creator={creator} />
      <td
        className={`${TD} font-mono text-xs tabular-nums text-text-secondary`}
      >
        {formatFollowers(creator.followers)}
      </td>
      <td
        className={`${TD} font-mono text-[11px] tabular-nums text-text-tertiary`}
      >
        {formatDate(creator.created)}
      </td>
    </tr>
  );
}

type Props = { creators: Creator[]; onSelect: (id: string) => void };

export function RecentCreatorsTable({ creators, onSelect }: Props): ReactNode {
  return (
    <div className="overflow-hidden rounded-xl bg-white/[0.02]">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[400px] text-left">
          <tbody>
            {creators.map((l) => (
              <Row key={l.id} creator={l} onClick={() => onSelect(l.id)} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
